export function setupInfiniteHScrolling() {
  const scrollContainer = document.querySelector(".scroll-container");
  const scrollItems = document.querySelector(".scroll-items");

  if (!scrollContainer || !scrollItems) return;

  const cloneItems = scrollItems.cloneNode(true);
  scrollContainer.appendChild(cloneItems);

  let scrollSpeed =
    parseFloat(scrollContainer.getAttribute("data-speed")) || 0.2;
  let hoverPause = scrollContainer.getAttribute("data-hover-pause") === "true";
  let scrollPosition = 0;
  let isHovering = false;

  function moveScroll() {
    if (!isHovering || !hoverPause) {
      scrollPosition += scrollSpeed;

      if (scrollPosition >= 100) {
        scrollPosition = 0;
      }

      scrollItems.style.transform = `translateX(-${scrollPosition}%)`;
      cloneItems.style.transform = `translateX(-${scrollPosition}%)`;
    }

    requestAnimationFrame(moveScroll);
  }

  requestAnimationFrame(moveScroll);

  const childItems = scrollContainer.querySelectorAll(".scroll-items");

  childItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      isHovering = true;
    });

    item.addEventListener("mouseleave", () => {
      isHovering = false;
    });
  });
}
